<template>
  <vs-row :class="[ size === 'small' ? 'input-group-small' : 'input-group' ] " vs-w="12" type="flex">
    <vs-col class="flex justify-start items-center" vs-w="2"  vs-lg="1" style="padding:0;" >
      <div :class="[  ( size === 'small' ? 'color-chip-small' : 'color-chip' ) , status ]" />
    </vs-col>
    <vs-col class="flex justify-start  items-center" vs-w="10"  style="padding:0;" >
      <span class="container-data-title" :class="[ ( size === 'large' ? 'aisea-text-18-700-blue' : size === 'small' ? 'aisea-text-14-400-black' : 'aisea-text-14-700-black' ) ]">
        {{ name }}
      </span>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  props: {
    status: { type: String },  // ステータス表示名がそのままランプ表示のクラス名になる。
    name:   { type: String },
    size:   { type: String },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.input-group {
  padding: 0.2rem 0.4rem;
}
.input-group-small {
  padding: 0.1rem;
}

.container-data-title {
  margin-left: 1.1rem;
}
.color-chip-small {
  min-width: 15px;
  max-width: 15px;
  height:    15px;
  border-radius: 50%;
  margin-left: 2px;
}
.color-chip {
  min-width: 20px;
  max-width: 20px;
  height:    20px;
  border-radius: 50%;
}
.active {
  background-color: $aisea-green;
  border: 2px solid rgba($aisea-green, 0.5);
  background-clip: padding-box;
}
.alert {
  background-color: $aisea-pink;
  border: 2px solid rgba($aisea-pink, 0.5);
  background-clip: padding-box;
}
.interlock {
  background-color: $aisea-mouse-gray;
  border: 2px solid rgba($aisea-mouse-gray, 0.5);
  background-clip: padding-box;
}
.power-off, .UNKNOWN {
  background-color: $aisea-light-gray;
  border: 2px solid $aisea-mouse-gray;
  background-clip: padding-box;
}
</style>
